import { useProduct } from '@/entities/product';
import { usePurchaseFormState } from '@/entities/purchase-form';
import { useHasOnlyCartSubmitError } from '@/widgets/product-details/purchase-panel/model/useHasOnlyCartSubmitError';

export const useIsFormValid = () => {
    const { product, isLoading, isError } = useProduct();

    const { hasOnlyCartSubmitError } = useHasOnlyCartSubmitError();
    const formState = usePurchaseFormState();

    const hasErrors = Boolean(Object.keys(formState.errors).length);
    const isFormStateValid = (formState.isValid && !hasErrors) || hasOnlyCartSubmitError;

    const isPharmacyOOS = Boolean(product?.pharmacy?.oos);
    const hasDeliveryMethods = Boolean(product?.deliveryMethodsList.length);

    const isValid = isFormStateValid && hasDeliveryMethods && !isPharmacyOOS && !isLoading && !isError;

    return { isValid };
};
